module.exports = __webpack_public_path__ + "img/normal.598537f0.png";